// extracted by mini-css-extract-plugin
export var accordion = "styles-module__accordion___pduWI";
export var accordionExpanded = "styles-module__accordionExpanded___U6vPN";
export var details = "styles-module__details___pzHZT";
export var summary = "styles-module__summary___mmqXW";
export var summaryExpanded = "styles-module__summaryExpanded___wn5sv";
export var summaryTitle = "styles-module__summaryTitle___m1dkx";